
import { Skeleton } from "@/components/ui/skeleton";

export const Loading = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-16 md:pt-20">
      <div className="container py-1 px-1 md:px-4 md:py-4">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2 bg-white p-4 rounded-lg shadow-sm">
          <div className="flex flex-col gap-1">
            <Skeleton className="h-8 w-48" />
            <Skeleton className="h-5 w-32" />
          </div>
          <Skeleton className="h-10 w-24" />
        </div>

        <div className="bg-white rounded-lg overflow-hidden">
          <div className="aspect-[16/9] relative">
            <Skeleton className="w-full h-full absolute inset-0" />
          </div>
          
          <div className="p-2 md:p-4 space-y-6">
            <div className="space-y-3">
              <Skeleton className="h-7 w-3/4" />
              <div className="space-y-2">
                <Skeleton className="h-5 w-full" />
                <Skeleton className="h-5 w-full" />
                <Skeleton className="h-5 w-2/3" />
              </div>
            </div>
            
            <div className="space-y-3">
              <Skeleton className="h-6 w-32" />
              <div className="grid grid-cols-3 gap-3">
                <Skeleton className="h-16 w-full" />
                <Skeleton className="h-16 w-full" />
                <Skeleton className="h-16 w-full" />
              </div>
            </div>
            
            <div className="space-y-3">
              <Skeleton className="h-6 w-40" />
              <div className="space-y-2">
                <Skeleton className="h-5 w-full" />
                <Skeleton className="h-5 w-3/4" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
